export default __webpack_public_path__ + "static/media/banner-md-1000px.6baa3fa5.png";